export default {
  name: 'status',
  components: {},
  props: ['status', 'checklist_item_status', 'checklist_item'],
  data () {
    return {

    }
  },
  computed: {
    checklist () {
      return this.$store.getters['Checklist/showChecklist']
    }
  },
  mounted () {
  },
  methods: {
    selectStatus (status) {
      if (status.code === this.checklist_item.checklist_item_status.code) {
        return false
      }
      this.$loading.start()
      this.$store.dispatch('Audit/changeStatusChecklistItemOfChecklist', {checklist: {id: this.$route.params.checklist_id}, checklist_item: this.checklist_item, status}).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        if (status.is_report) {
          this.$store.commit('Audit/openCommentOfChecklistItem', this.checklist_item)
          this.$store.dispatch('Comment/getListCommentOfChecklistItem', {checklist: {id: this.$route.params.checklist_id}, checklist_item: this.checklist_item}).then(res => {
            this.checklist_item.comments = res.cmts
            this.checklist_item.cmt_crv = res.cmt_crv
            this.$store.commit('Audit/addCommentToChecklistItem', this.checklist_item)
            this.$loading.complete()
          }).catch(errors => {
            this.$loading.fail()
          })
        } else {
          this.$store.commit('Audit/closeCommentOfChecklistItem', this.checklist_item)
        }
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/checklist-item/status/status.js